import UserCheckIcon from '@/assets/icons/user-check.svg?react';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetUnifiedProfileQuery } from '@/services/endpoints/unifiedProfiles';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { UnifiedProfileSection, UnifiedProfileSectionHeader, UnifiedProfileTile } from '../../common';
import { UnifiedProfileDetailsSectionItem } from '../UnifiedProfileDetailsSection/UnifiedProfileDetailsSectionItem';

export const UnifiedProfileTraitsSection: FC = () => {
  const { id: unifiedProfileId } = useParams<{ id: string }>();
  const workspace = useWorkspace();

  const { data: unifiedProfile } = useGetUnifiedProfileQuery({
    unifiedProfileId,
    workspaceId: workspace.id,
  });

  return (
    <UnifiedProfileSection>
      <UnifiedProfileTile className='flex flex-col gap-6 px-6 py-8'>
        <UnifiedProfileSectionHeader labelKey='identifiedTraits' icon={<UserCheckIcon />} />
        <div className='grid grid-cols-1 gap-x-24 gap-y-6 lg:grid-cols-2'>
          <UnifiedProfileDetailsSectionItem label={'name'} options={unifiedProfile?.firstName} />
          <UnifiedProfileDetailsSectionItem label={'surname'} options={unifiedProfile?.lastName} />
          <UnifiedProfileDetailsSectionItem label={'birthday'} options={unifiedProfile?.birthday} />
          <UnifiedProfileDetailsSectionItem label={'email'} options={[unifiedProfile?.email]} />
          <UnifiedProfileDetailsSectionItem label={'lastUpdated'} options={[unifiedProfile?.profileUpdatedAt]} />
          <UnifiedProfileDetailsSectionItem label={'website'} options={unifiedProfile?.website} />
          <UnifiedProfileDetailsSectionItem label={'gender'} options={unifiedProfile?.gender} />
          <UnifiedProfileDetailsSectionItem label={'title'} options={unifiedProfile?.title} />
          {unifiedProfile?.customTraits
            ? Object.entries(unifiedProfile?.customTraits).map((entry) => (
                <UnifiedProfileDetailsSectionItem key={entry[0]} label={entry[0]} options={entry[1]} />
              ))
            : null}
        </div>
      </UnifiedProfileTile>
    </UnifiedProfileSection>
  );
};
